/// <amd-module name="VSSUI/Components/Coin/Coin.Initials" />
import { IColor } from "VSSUI/Utilities/Color";

const COIN_COLOR_BLUE: IColor = { red: 79, green: 107, blue: 237 }; // Blue10
const COIN_COLOR_PALETTE: IColor[] = [
    { red: 117, green: 11, blue: 28 }, // PinkRed10
    { red: 164, green: 38, blue: 44 }, // Red20
    { red: 209, green: 52, blue: 56 }, // Red10
    { red: 202, green: 80, blue: 16 }, // Orange20
    { red: 152, green: 111, blue: 11 }, // OrangeYellow20
    { red: 73, green: 130, blue: 5 }, // Green10
    { red: 11, green: 106, blue: 11 }, // Green20
    { red: 3, green: 131, blue: 135 }, // Cyan20
    { red: 0, green: 91, blue: 112 }, // Cyan30
    { red: 0, green: 120, blue: 212 }, // CyanBlue10
    COIN_COLOR_BLUE,
    { red: 92, green: 46, blue: 145 }, // BlueMagenta30
    { red: 135, green: 100, blue: 184 }, // BlueMagenta20
    { red: 136, green: 23, blue: 152 }, //  Magenta20
    { red: 194, green: 57, blue: 179 }, //  Magenta10
    { red: 227, green: 0, blue: 140 }, //  MagentaPink10
    { red: 142, green: 86, blue: 46 }, //  Orange30
    { red: 122, green: 117, blue: 116 }, //  Gray30
    { red: 105, green: 121, blue: 126 } //  Gray20
];

// Char.IsLetter ranges
const LETTERS: string[] = [
    "[\u0030-\u0039]", // NUMBER 0 - NUMBER 9 (eg. 1Es)
    "[\u0041-\u005A]", // LATIN CAPITAL LETTER A - LATIN CAPITAL LETTER Z
    "[\u0400-\u042F]", // CYRILLIC CAPITAL LETTER IE WITH GRAVE - CYRILLIC CAPITAL LETTER YA
    "[\u0061-\u007A]", // LATIN SMALL LETTER A - LATIN SMALL LETTER Z
    "[\u03AC-\u03CE]", // GREEK SMALL LETTER ALPHA WITH TONOS - GREEK SMALL LETTER OMEGA WITH TONOS
    "[\u01C5]", // LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON
    "[\u1FFC]", // GREEK CAPITAL LETTER OMEGA WITH PROSGEGRAMMENI
    "[\u02B0-\u02C1]", // MODIFIER LETTER SMALL H - MODIFIER LETTER REVERSED GLOTTAL STOP
    "[\u1D2C-\u1D61]", // MODIFIER LETTER CAPITAL A - MODIFIER LETTER SMALL CHI
    "[\u05D0-\u05EA]", // HEBREW LETTER ALEF - HEBREW LETTER TAV
    "[\u0621-\u063A]", // ARABIC LETTER HAMZA - ARABIC LETTER GHAIN
    "[\u4E00-\u9FC3]", // <CJK Ideograph, First> - <CJK Ideograph, Last>
    "[\u00C0-\u00FF]", // LATIN-1 SUPPLEMENT
    "[\u0100-\u017F]", // LATIN-1 EXTENDED-A
    "[\u0180-\u024F]" // LATIN-1 EXTENDED-B
];

const LETTERS_REGEX = LETTERS.join("|");

export function getInitialsColorFromName(displayName: string | undefined): IColor {
    if (!displayName) {
        return COIN_COLOR_BLUE;
    }

    let hashCode = 0;
    for (let i: number = displayName.length - 1; i >= 0; i--) {
        const ch: number = displayName.charCodeAt(i);
        const shift: number = i % 8;
        // tslint:disable-next-line:no-bitwise
        hashCode ^= (ch << shift) + (ch >> (8 - shift));
    }

    return COIN_COLOR_PALETTE[hashCode % COIN_COLOR_PALETTE.length];
}

export function getInitialsFromName(displayName: string | undefined): string {
    if (!displayName) {
        return "";
    }

    const segments: string[] = displayName.split(" ").filter(x => x !== "");
    if (segments.length === 0) {
        return "";
    }

    let firstNameInitial = "";
    let lastNameInitial = "";

    segments.forEach(segment => {
        if (segment[0].match(LETTERS_REGEX)) {
            if (firstNameInitial.length === 0) {
                firstNameInitial = segment[0];
            } else {
                lastNameInitial = segment[0];
            }
        }
    });

    return firstNameInitial.concat(lastNameInitial).toUpperCase();
}
